module.exports = __webpack_public_path__ + "static/media/access-phone-girl.7791b472.png";